import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { cn } from "@/lib/utils/common";

export function Spinner({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "text-muted-foreground inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]",
        className,
      )}
      role="status"
    >
      <VisuallyHidden>Loading...</VisuallyHidden>
    </div>
  );
}
